import { mockDataSideBySide } from "./mockDataSideBySide";
import { mockDataPreview } from "./mockDataPreview";
import { mockDataDuplicates } from "./mockDataDuplicates";
import { mockDataDuplicateStatus } from "./mockDataDuplicateStatus";
import { mockDataPromoteCandidate } from "./mockDataPromoteCandidate";
import { mockDataUndoPromoteCandidate } from "./mockDataUndoPromoteCandidate";

const use_mock_data = false;

// 🚨 DO NOT EDIT THIS LINE 🚨
const USE_MOCK_DATA_PROTECTED =
  process.env.NODE_ENV === "development" ? use_mock_data : false;

export const mockData = {
  USE_MOCK_DATA: USE_MOCK_DATA_PROTECTED,
  sideBySide: mockDataSideBySide,
  preview: mockDataPreview,
  duplicates: mockDataDuplicates,
  duplicateStatus: mockDataDuplicateStatus,
  promoteCandidate: mockDataPromoteCandidate,
  undoPromoteCandidate: mockDataUndoPromoteCandidate,
};
